import ResponsiveTable from './ResponsiveTable';
import React from 'react';
import { Button } from 'react-bootstrap';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { MdPlayArrow } from 'react-icons/md';
import moment from 'moment';
import './VideoBrowser.css';

const filename = video => video?.path?.split('/').pop() || 'Gravação sem arquivo';

export default function VideoBrowser({ videos, selectedVideo, onSelect, page, lastPage, onPageChange, loading, mediaError, onMediaError }) {
  const index = videos.findIndex(video => video.id === selectedVideo?.id);
  const previous = () => index > 0 ? onSelect(videos[index - 1]) : onPageChange(page - 1, true);
  const next = () => index < videos.length - 1 ? onSelect(videos[index + 1]) : onPageChange(page + 1);
  return <div className="video-browser">
    {selectedVideo && <>
      <div className="video-browser-player">
        {selectedVideo.url && !selectedVideo.url.includes('video_not_found') ? <video key={selectedVideo.id} controls height="300" preload="metadata" src={selectedVideo.url} onError={onMediaError} aria-label={`Gravação com ${selectedVideo.user?.name || 'candidato'}`} /> : <p>Vídeo indisponível.</p>}
        {mediaError && <p role="alert">Não foi possível reproduzir esta gravação. Tente outro vídeo ou atualize os registros.</p>}
      </div>
      <p className="video-browser-filename">{filename(selectedVideo)}</p>
      <div className="flex jcsb flex-wrap mb-4 video-browser-controls hidethis">
        <Button variant="success" onClick={previous} disabled={loading || index < 0 || (index === 0 && page === 1)} className="flex align-center jcc"><FaArrowLeft /> Anterior</Button>
        <Button variant="success" onClick={next} disabled={loading || index < 0 || (index === videos.length - 1 && page >= lastPage)} className="flex align-center jcc">Próximo <FaArrowRight /></Button>
      </div>
      <hr />
    </>}
    <div className="table-rep-plugin"><div className="table-responsive mb-0"><ResponsiveTable className="table table-striped">
      <thead><tr><th>Nome</th><th>Data e hora</th><th>Candidato</th><th>Tipo</th><th className="hidethis">Ações</th></tr></thead>
      <tbody>{videos.map(video => <tr key={video.id} style={{ backgroundColor: selectedVideo?.id === video.id ? '#4BB543' : '' }}>
        <td>{filename(video)}</td><td>{video.date || video.created_at ? moment(video.date || video.created_at).format('DD/MM/YYYY HH:mm:ss') : '—'}</td><td>{video.user?.name || 'Candidato não identificado'}</td><td>{video.type === 'screen' ? 'Tela' : 'Câmera'}</td>
        <td className="hidethis"><button type="button" onClick={() => onSelect(video)} className="inline-flex align-center jcc bg-info icon video-browser-play" title="Gerenciar vídeo" aria-label={`Assistir ${filename(video)}`}><MdPlayArrow size={17} color="white" /></button></td>
      </tr>)}</tbody>
    </ResponsiveTable></div></div>
  </div>;
}
